export default "__VITE_ASSET__91659ec9__"